import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSkipEmi,
  updateSkipEmi,
} from '../redux/slices/skipEmiSlice';
import '../modalstyles/SkipEmiModal.css';

const SkipEmiModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const { days, loading, error } = useSelector((state) => state.skipEmi);

  useEffect(() => {
    dispatch(fetchSkipEmi());
  }, [dispatch]);

  const handleToggle = (id, day, currentStatus) => {
    dispatch(updateSkipEmi({ id, day, status: !currentStatus }));
  };

  return (
    <div className="SkipEmiModal-backdrop">
      <div className="SkipEmiModal-modal">
        <div className="SkipEmiModal-header">
          <h3 className="SkipEmiModal-title">Skip EMI On</h3>
          <button onClick={onClose} className="SkipEmiModal-closeBtn">
            &times;
          </button>
        </div>

        <div className="SkipEmiModal-body">
          {loading && <p>Loading...</p>}
          {error && <p className="error">{error}</p>}
          {!loading &&
            days.map(({ id, day, status }) => (
              <div key={id} className="SkipEmiModal-dayRow">
                <label className="day-label">{day}</label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={status}
                    onChange={() => handleToggle(id, day, status)}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            ))}
        </div>

        <div className="SkipEmiModal-footer">
          <button onClick={onClose} className="SkipEmiModal-saveBtn">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SkipEmiModal;
